<template>
  <div class="app-container">
    <h1>{{ $t('message.tasas.menu.consultarDeclaraciones.titulo') }}</h1>
    <v-form ref="formFiltro" lazy-validation>
      <v-container fluid class="search">
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              v-model="filtroTabla"
              :placeholder="$t('message.comun.textoBusqueda')"
              append-outer-icon="search"
              solo
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-alert :value="true" color="info" icon="info" outline>
      {{ $t('message.comun.infoVisualizacion') }}
    </v-alert>
    <v-data-table
      id="resultadosTabla"
      :headers="fields"
      :items="declaraciones"
      :no-data-text="$t('message.comun.sinDeclaracion')"
      :no-results-text="$t('message.comun.sinResultadosBusqueda')"
      :search="filtroTabla"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.feperdecPublic }}</td>
        <td class="text-xs-center">{{ props.item.fefinfacPublic }}</td>
        <td class="text-xs-center">{{ props.item.fepresenPublic }}</td>
        <td class="text-xs-center">{{ textoCdRegist(props.item.cdregist) }}</td>
        <td class="text-xs-center">{{ props.item.nujustas }}</td>
        <td class="text-xs-center">
          <Icono
            v-if="
              props.item.cdregist != null &&
                props.item.cdregist != 'PENDIENTE_REGISTRO' &&
                props.item.cdregist.length > 15
            "
            :id="'editar' + props.item.id"
            :payload="props.item"
            color="success"
            class="mr-2"
            :tooltip="$t('message.comun.justificante.tooltipRegistro')"
            @click="getJustificanteHandler"
            >how_to_reg
          </Icono>
          <Icono
            v-if="
              props.item.cdregist != null &&
                props.item.cdregist != 'PENDIENTE_REGISTRO' &&
                props.item.cdregist.length > 15
            "
            :id="'eliminar' + props.item.id"
            :payload="props.item"
            color="info"
            :tooltip="$t('message.comun.justificante.tooltipNumero')"
            @click="getCartaDePagoHandler"
            >description</Icono
          >
          <Icono
            v-if="props.item.cdregist == 'PENDIENTE_REGISTRO'"
            color="info"
            :tooltip="$t('message.comun.justificante.enProcesoToolTip')"
            >info
          </Icono>
        </td>
      </template></v-data-table
    >
  </div>
</template>

<script>
import { TIPO_DECLARACION_TASA } from './constTasas';
import { Icono } from '@/components';
import { mapActions, mapGetters } from 'vuex';
import { getDeclaraciones, getJustificante, getCartaDePago } from '@/api/declaraciones';
import { notificarError } from '@/utils/notification';
import logger from '@/utils/logger';
import moment from 'moment';

export default {
  name: 'tasas',
  data() {
    let fields = [
      {
        value: 'feperdecPublic',
        text: this.$t('message.comun.mesDeclaracion'),
        align: 'center',
        sortable: false
      },
      {
        value: 'fefinfacPublic',
        text: this.$t('message.comun.mesFacturacion'),
        align: 'center',
        sortable: false
      },
      {
        value: 'fepresenPublic',
        text: this.$t('message.comun.fechaPresentacion'),
        align: 'center',
        sortable: false
      },
      {
        value: 'cdregist',
        text: this.$t('message.comun.justificante.codigoRegistro'),
        align: 'center',
        sortable: true
      },
      {
        value: 'nujustas',
        text: this.$t('message.comun.justificante.numero'),
        align: 'center',
        sortable: true
      },
      {
        value: 'actions',
        text: this.$t('message.tasas.periodo.actions'),
        align: 'center',
        sortable: false
      }
    ];
    return {
      filtros: {
        idempres: null,
        cdtipdec: TIPO_DECLARACION_TASA,
        paginaActual: 1,
        registrosPagina: 1000
      },
      filtroTabla: '',
      pagination: { sortBy: 'nujustas', descending: true },
      fields: fields,
      declaraciones: []
    };
  },
  components: {
    Icono
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Tasas', to: '/tasas', disabled: false },
        { text: 'Consulta Tasas', to: '/tasas/consulta', disabled: true }
      ],
      menuSelected: '/tasas/presentacion-tasa'
    });
    this.consultar();
  },
  computed: {
    ...mapGetters(['empresaSelected', 'userNIFCIF', 'userName'])
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    allowedMonths(val) {
      return (
        moment(val).toDate() <=
        moment()
          .startOf()
          .date(0)
          .toDate()
      );
    },
    consultar() {
      this.filtros.idempres = this.empresaSelected.idempres;
      this.filtros.cdtipemp = this.empresaSelected.cdtipemp;
      let self = this;
      this.setLoading(true);
      // Preparamos el payload
      getDeclaraciones(this.filtros)
        .then(response => {
          self.declaraciones = response.data;
        })
        .catch(error => {
          notificarError(this, error);
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    getCartaDePagoHandler(payload) {
      getCartaDePago(payload.cdregist)
        .then(response => {
          // Info del fichero
          var bData = new Blob([response.data], {
            type: 'application/pdf'
          });
          var nombre = payload.nujustas + '.pdf';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(bData, nombre);
          } else {
            const url = window.URL.createObjectURL(bData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          logger.print(error);
        });
    },
    getJustificanteHandler(payload) {
      getJustificante(payload.cdregist)
        .then(response => {
          // Info del fichero
          var bData = new Blob([response.data], {
            type: 'application/pdf'
          });
          var nombre = payload.cdregist + '.pdf';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(bData, nombre);
          } else {
            const url = window.URL.createObjectURL(bData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          logger.print(error);
        });
    },
    textoCdRegist(cdregist) {
      return cdregist != 'PENDIENTE_REGISTRO' ? cdregist : 'Procesando...';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';
.search {
  background-color: $color-secondary;
  margin-bottom: 20px !important;
  padding: 15px 15px 0px 15px !important;
  .v-input__slot {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    margin: 0px !important;
    border: 0.5px solid;
    border-color: #999999;
    box-shadow: none;
  }
  .v-input__append-outer {
    background-color: #eca407 !important;
    min-width: 60px !important;
    margin: 0px !important;
    padding: 12px !important;
    i {
      font-weight: bold important;
    }
  }
}
</style>
